import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Directive({
  selector: '[appCopyValue]'
})
export class CopyValueDirective {

  @Input() appCopyValue: AbstractControl;

  constructor(private element: ElementRef) { }

  @HostListener('change', [ '$event' ])
  onChange($event) {
    if (this.appCopyValue.untouched) {
      this.appCopyValue.setValue(this.element.nativeElement.value);
    }
  }
}
